<template>
  <div class="upgrade-authorize" v-if="isShowAuthorize">
    <div class="authorize">
      <div class="authorize-btn button ghost" @click="requestHIDAccess">{{ $t('allow_browser') }}</div>
      <div class="authorize-des">{{ $t('allow_browser_desc') }}</div>
      <div class="authorize-img">
        <div class="img-box">
          <div class="title">{{ $t('allow_browser_desc1') }}</div>
          <img class="img" v-if="bd == Brand.irok" src="@/assets/img/irok_authorize.png" />
          <img class="img" v-else-if="bd == Brand.iyx" src="@/assets/img/iyx_authorize.png" />
          <img class="img" v-else-if="bd == Brand.carotmas" src="@/assets/carotmas/authorize.png" />
        </div>
        <div class="img-box">
          <div class="title">{{ $t('allow_browser_desc2') }}</div>
          <img class="img" src="@/assets/img/authorize2.png" />
        </div>
        <div class="img-box" v-if="bd == Brand.carotmas">
          <div class="title">{{ $t('allow_browser_desc3') }}</div>
          <img class="img" src="@/assets/carotmas/authorize3.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
const isShowAuthorize = ref(true)

export { isShowAuthorize }
</script>
<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { DriverService } from '@/service/driver/driver'
import { DriverSocketMsgType } from '@libs/types/message'
import { Brand, getBrand } from '@/brand/brand'
const bd = ref(Brand.irok)
onMounted(async () => {
  bd.value = await getBrand()
})

const requestHIDAccess = () => DriverService.instance.askType(DriverSocketMsgType.MSRequestDevice)
</script>

<style scoped lang="less">
.upgrade-authorize {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.authorize {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .authorize-btn {
    font-size: 18px;
    font-weight: 600;
    padding: 14px 48px;
  }

  .authorize-des {
    margin-top: 60px;
    color: rgba(255, 255, 255, 0.9);
    font-size: 18px;
    font-weight: 500;
    opacity: 0.8;
  }

  .authorize-img {
    display: flex;
    margin-top: 24px;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: var(--radius-l);
    padding: 40px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);

    .img-box {
      margin-left: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .title {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.9);
        font-weight: 500;
        margin-bottom: 20px;
      }

      .img {
        height: 180px;
        border-radius: var(--radius-s);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
      }
    }

    .img-box:nth-child(1) {
      margin-left: 0px;
    }
  }
}
</style>
